module.exports = __webpack_public_path__ + "img/donate-wechatpay-20.22611b88.png";